// constant files

export const ADD_LEAVE_FINANCIAL_REQUEST = "ADD_LEAVE_FINANCIAL_REQUEST";
export const ADD_LEAVE_FINANCIAL_SUCCESS = "ADD_LEAVE_FINANCIAL_SUCCESS";
export const ADD_LEAVE_FINANCIAL_FAIL = "ADD_LEAVE_FINANCIAL_FAIL";

export const UPDATE_LEAVE_FINANCIAL_REQUEST = "UPDATE_LEAVE_FINANCIAL_REQUEST";
export const UPDATE_LEAVE_FINANCIAL_SUCCESS = "UPDATE_LEAVE_FINANCIAL_SUCCESS";
export const UPDATE_LEAVE_FINANCIAL_FAIL = "UPDATE_LEAVE_FINANCIAL_FAIL";

export const DELETE_LEAVE_FINANCIAL_REQUEST = "DELETE_LEAVE_FINANCIAL_REQUEST";
export const DELETE_LEAVE_FINANCIAL_SUCCESS = "DELETE_LEAVE_FINANCIAL_SUCCESS";
export const DELETE_LEAVE_FINANCIAL_FAIL = "DELETE_LEAVE_FINANCIAL_FAIL";

export const GETALL_LEAVE_FINANCIAL_REQUEST = "GETALL_LEAVE_FINANCIAL_REQUEST";
export const GETALL_LEAVE_FINANCIAL_SUCCESS = "GETALL_LEAVE_FINANCIAL_SUCCESS";
export const GETALL_LEAVE_FINANCIAL_FAIL = "GETALL_LEAVE_FINANCIAL_FAIL";

export const GETDETAIL_LEAVE_FINANCIAL_REQUEST =
  "GETDETAIL_LEAVE_FINANCIAL_REQUEST";
export const GETDETAIL_LEAVE_FINANCIAL_SUCCESS =
  "GETDETAIL_LEAVE_FINANCIAL_SUCCESS";
export const GETDETAIL_LEAVE_FINANCIAL_FAIL = "GETDETAIL_LEAVE_FINANCIAL_FAIL";
export const CLEAR_LEAVE_FINANCIAL_RECORD = "CLEAR_LEAVE_FINANCIAL_RECORD";
